import "./HomeRound5.css";
import "./blue2/base.css";
import { useFonts } from "./blue2/bits";
import { EventStrip, STRIP_VARIANTS } from "./blue2/EventStrip";

/* Reference for the event-bar styles: every variant stacked above a slice of
   the blue-2 nav, so a style can be picked in context. "original" is the one
   in use; the rest are kept for later (e.g. admin-picked presets). */
export function EventStripLab() {
  useFonts();
  return <div style={{ background: "#e9e6e0", padding: "70px 0 40px" }}>
    <style>{"@media (max-width: 900px) { .lab-links { display: none } }"}</style>
    {STRIP_VARIANTS.map(v => <section key={v} style={{ marginTop: 28 }}>
      <p style={{ margin: "0 0 6px 16px", font: "800 12px Figtree, sans-serif", letterSpacing: ".14em", textTransform: "uppercase", color: "#333" }}>{v}</p>
      <EventStrip variant={v} force />
      <div style={{ height: 70, display: "flex", alignItems: "center", gap: 40, padding: "0 3vw", background: "radial-gradient(60% 120% at 50% 0%, #2a85bf, transparent 70%), #05649B", color: "#FBF3E4" }}>
        <span style={{ font: "700 30px 'Amatic SC', cursive", whiteSpace: "nowrap" }}>A Few Loose Threads</span>
        <span className="lab-links" style={{ font: "600 12px Figtree, sans-serif", letterSpacing: ".06em", opacity: .9 }}>ABOUT · PROJECTS · THE CLUB · SHOP · JOURNAL</span>
        <span style={{ marginLeft: "auto", padding: "10px 20px", borderRadius: 99, background: "#F0BE3C", color: "#0B302A", font: "700 14px Figtree, sans-serif", whiteSpace: "nowrap" }}>Sew with me →</span>
      </div>
    </section>)}
  </div>;
}
